import React from 'react';
import {Helmet} from "react-helmet";

const Person = ({translate, name, profession}) => (
	<div className="person-info">
		<h1 className="name">{translate(name)}</h1>
		<p className="text-muted">{translate(profession)}</p>

		<Helmet>
			<meta property="og:title" content={translate(name)}/>
			<meta property="og:description" content={translate(profession)}/>
		</Helmet>
	</div>
);

export default Person;



// WEBPACK FOOTER //
// ./src/components/elements/About/Person.js